var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVideoqa = function SvgVideoqa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#videoqa_svg__a)",
    stroke: "#203040"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.062 17.724H3.879a1.465 1.465 0 0 1-1.462-1.462V4.207c0-.806.656-1.463 1.462-1.463h16.242c.806 0 1.462.657 1.462 1.463v10.996a2.525 2.525 0 0 1-2.521 2.521ZM3.879 3.703a.505.505 0 0 0-.504.504v12.056c0 .278.226.504.504.504h15.183c.862 0 1.563-.702 1.563-1.563V4.207a.505.505 0 0 0-.504-.504H3.879Z",
    fill: "#203040",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.583 21.583-.607-.168a7.36 7.36 0 0 1-1.549-.661c-1.097-.634-1.677-1.439-1.677-2.327 0-.814.335-1.223.618-1.423.316-.224.633-.236.694-.236.877 0 1.547.244 1.993.723a2.02 2.02 0 0 1 .528 1.42v2.672Zm-2.512-3.859c-.09.009-.363.084-.363.701 0 .865 1.098 1.513 1.917 1.852l.001-1.416s.016-.417-.281-.728c-.257-.27-.685-.406-1.274-.409Z",
    fill: "#203040",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.992 11.521c-1.933 0-3.585.293-3.585 1.464 0 1.17 1.641 1.474 3.585 1.474 1.934 0 3.585-.293 3.585-1.464 0-1.17-1.64-1.473-3.585-1.473ZM11.992 9.852a2.298 2.298 0 1 0-2.298-2.299 2.29 2.29 0 0 0 2.282 2.299h.016Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "videoqa_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .349)",
    d: "M0 0h23v23H0z"
  })))));
};

export default SvgVideoqa;